import type { ReactElement } from 'react';
import { SupportedLanguage } from 'src/common/contexts/language-context';
import { CampaignType } from 'src/features/admin/campaigns/campaigns.types';
export interface CampaignConfigDefaultProps {
  isActive: boolean;
  influencerIcon?: string;
  name: string;
  userFriendlyName: string;
  percentageOff: number;
  source?: string;
  type: CampaignType;
  urlPath?: string;
  utmCampaign?: string;
}
export interface InfluencerConfig {
  userFriendlyName: string;
  urlToNavigate: string;
  page: string;
  pagesToShowCTA: string[];
  barCta: (userFriendlyName: string, percentageOff: number, isOnboarding: boolean, language: SupportedLanguage) => ReactElement;
  isActive: boolean;
  percentageOff: number;
  icon?: string;
  landingRedirect?: string;
  detailsRedirect?: string;
  details?: string;
  isGradient?: boolean;
}
export type InfluencerIcon = {
  InfluencerIcon: React.FC<React.SVGProps<SVGSVGElement>>;
};
export type InfluencerAdditionalConfigs = Record<string, InfluencerConfig & InfluencerIcon>;
export type InfluencerSubscriptionAdditionalConfigs = Record<string, InfluencerConfig & InfluencerIcon>;
const DEFAULT_PAGES_TO_SHOW_CTA = ['/certification/junior-penetration-tester', '/welcome', '/dashboard/*'];
const DEFAULT_PAGES_TO_SHOW_CTA_SUBSCRIPTION = ['/', '/dashboard/*', ''];
const DEFAULT_PAGE = '/certification/junior-penetration-tester';
const DEFAULT_PAGE_SUBSCRIPTION = '/';
const DEFAULT_DETAILS = '/certification/junior-penetration-tester/details';
const DEFAULT_UTMS = 'utm_source=youtube&utm_medium=social&utm_campaign=';
const barCta = (userFriendlyName: string, percentageOff: number, isOnboarding: boolean): ReactElement => {
  if (isOnboarding) {
    return <>
        {userFriendlyName} viewers exclusive: <span>{percentageOff}% off</span> Jr Penetration Tester certification!
        Finish onboarding to claim your discount.
      </>;
  }
  return <>
      {userFriendlyName} viewers exclusive: <span>{percentageOff}% off</span> Jr Penetration Tester certification!
    </>;
};
const barCtaSubscription = (userFriendlyName: string, percentageOff: number, isOnboarding: boolean, language?: SupportedLanguage, hideInfluencerDetails = false): ReactElement => {
  if (language === SupportedLanguage.FRENCH) {
    if (isOnboarding) {
      return <>
          Offre exclusive {userFriendlyName}: <span>-{percentageOff}%</span> sur les abonnements annuels! Terminez
          l’onboarding pour vous abonner.
        </>;
    }
    return <>
        Offre exclusive {userFriendlyName}: <span>-{percentageOff}%</span> sur les abonnements annuels!
      </>;
  }
  if (isOnboarding) {
    return <>
        {userFriendlyName} viewers exclusive: <span>{percentageOff}% off</span> annual subscriptions! Finish onboarding
        to Subscribe.
      </>;
  }
  return <>
      {!hideInfluencerDetails ? `${userFriendlyName} viewers exclusive` : 'Exclusive offer for you'}:{' '}
      <span>{percentageOff}% off</span> annual subscriptions!
    </>;
};
export const INFLUENCER_CONFIGS = ({
  isActive,
  influencerIcon,
  name,
  userFriendlyName,
  percentageOff,
  source,
  utmCampaign,
  type
}: CampaignConfigDefaultProps) => {
  let page = `${DEFAULT_PAGE_SUBSCRIPTION}?${DEFAULT_UTMS}${utmCampaign}`;
  if (name === 'REDDIT_2025') page = `${DEFAULT_PAGE_SUBSCRIPTION}?utm_source=reddit&utm_medium=cpc&utm_campaign=${utmCampaign}`;
  if (['STALESIGNUP25OCT25_2025', 'REJOIN_2025'].includes(name)) page = `/why-subscribe?${DEFAULT_UTMS}${utmCampaign}`;
  return {
    name: name,
    userFriendlyName: userFriendlyName,
    isActive,
    percentageOff,
    icon: influencerIcon,
    page,
    urlToNavigate: `/signup?source=${source}`,
    pagesToShowCTA: DEFAULT_PAGES_TO_SHOW_CTA_SUBSCRIPTION,
    barCta: barCtaSubscription,
    ...(type === CampaignType.EXAM ? {
      landingRedirect: `${DEFAULT_PAGE}?${DEFAULT_UTMS}${utmCampaign}`,
      detailsRedirect: `${DEFAULT_DETAILS}?${DEFAULT_UTMS}${utmCampaign}`,
      details: DEFAULT_DETAILS,
      page: DEFAULT_PAGE,
      urlToNavigate: `/login?source=${source}`,
      pagesToShowCTA: DEFAULT_PAGES_TO_SHOW_CTA,
      barCta
    } : {})
  };
};